import { TaskType } from '../../../../../clients/quipli-service/job-tasks/job-tasks';
import { Task } from '../../../../../clients/quipli-service/job-tasks/job-tasks';

/**
 * Checks if all tasks for a given unit are complete (regardless of success or failure).
 * @param tasks - The tasks.
 * @param unitId - The unit id.
 * @returns True if all tasks are complete, false otherwise.
 */
export const areUnitTasksComplete = (tasks: Task[], unitId: number): boolean => {
  const hoursTask = tasks.find((t) => t.metadata?.productUnitId === unitId && t.type === TaskType.MachineHours);
  const checklistTask = tasks.find(
    (t) => t.metadata?.productUnitId === unitId && t.type === TaskType.InspectionChecklist,
  );
  const mediaTask = tasks.find((t) => t.metadata?.productUnitId === unitId && t.type === TaskType.MediaUpload);

  const hoursComplete = !hoursTask || hoursTask.status === 'Complete';
  const checklistComplete = !checklistTask || checklistTask.status === 'Complete';
  const mediaComplete = mediaTask?.status === 'Complete';

  return hoursComplete && checklistComplete && mediaComplete;
};
